import React from "react";
import App from "../Layouts/AppLayout";
import { Section } from "../Components";

export default function PrivacyPolicy() {

  const contents = [
    {
      'title': 'Introduction',
      'body': <p>
        Your privacy is very important to us. We place a premium on protecting your information and have established these guiding principles to ensure that we continue to keep your trust and our vow of protecting your privacy and the security of all personal information you provide to us. <br />
        We will only ask you for information we actually need. We do not and will not share, sell or loan your personal information with anyone unless to comply with the law or protect your rights. For any personal information we store, we will do so with the utmost security, employing highest industry protection standards to keep your personal information safe.
      </p>,
      'summary': "We consider your privacy extremely important."
    },
    {
      'title': 'Website Information',
      'body': <p>
        We may collect tracking information on our website to let us know better how our website is used. This information is commonly used by web browsers and servers and does not identify the user. <br />
        We may use and disclose this information as statistics from time to time but not in any way identifying the personal identity of users. <br />
        Users who do not want this tracking information to be collected may do so by blocking cookies or any other tracking tools if this option is available on their browser however users do so with the knowledge that blocking this tools may hamper their user experience on the PayOnDelivery website.
      </p>,
      'summary': "We do not share your information."
    },
    {
      'title': 'Protection of Your Information',
      'body': <p>
        Only employees, contractors or affiliates that require access to your personal information to fulfill their job responsibilities or process it on behalf of PayOnDelivery are authorized to view your personal information. These entities would have agreed not to share or disclose your information to any other party or use the information for any other purpose other than that described above. By using the PayOnDelivery website you consent to the transfer of such information to these entities. We do not sell or rent your personal information to any of these entities or any other party. <br />
        We store this information with the utmost security, in compliance with and exceeding industry standards and applicable US federal and state regulations. We use computer safeguards such as firewalls and data encryption and enforce controlled access to our facilities. <br />
        When we transmit this data we use the highest level of security, Secure Sockets Layer (SSL) encryption technology to transmit this data. <br />
        As stated we do not disclose personal information unless required to do so by law or when PayOnDelivery believes in good faith that disclosure is necessary to protect PayOnDelivery's property rights or for the protection of third parties and/or the public at large. <br />
        As a registered PayOnDelivery user, we may communicate with you via your email you supplied to us during registration to keep you informed on changes, new features and products or information we deem necessary to be disseminated to you.
      </p>,
      'summary': "We keep your information secure."
    },
    {
      'title': 'Data retention and requesting data deletion',
      'body': <p>
        We respect your choices over your Personal Data. If for any reason you want your data deleted from our site you can do so by logging into your account and requesting data deletion by contacting <a href="mailto:customersupport@payondelivery.com" className="tw-underline tw-text-primary">customersupport@payondelivery.com</a> from your dashboard to delete your data. <br />
        When you request data deletion, we follow a deletion policy to make sure that your data is safely and completely removed from our servers. <br />
        We immediately start the process of removing the data safely and completely from our storage systems. Safe deletion is important to protect our users and customers from accidental data loss. Complete deletion of data from our servers is equally important for users’ peace of mind. We also ensure that there are no pending transactions or activity on the account to make sure the deletion is done safely without impact on other users. This process generally takes around 4 weeks from the time the request is made.
      </p>,
      'summary': "We'll remove your data safely from our site at your request"
    },
    {
      'title': 'Changes to this Policy',
      'body': <p>
        PayOnDelivery reserves the right to make changes to this privacy as needed or required. All policy changes as well as effective dates will be communicated to users via email or through this website.
      </p>,
      'summary': null
    },
  ]

  return (
    <App>
      <Section >
        <h1 className="tw-text-center">Privacy policy</h1>
      </Section>

      <div className="tw-space-y-4 tw-space-y-8 tw-pb-8 md:tw-pb-16">
        {contents.map((_, i) =>
          <Section key={i} pad={false} className="tw-grid tw-grid-cols-1 md:tw-grid-cols-3 tw-gap-4">
            <div className="md:tw-col-span-2">
              <h5 className="tw-text-primary">{_.title}</h5>
              {_.body}
            </div>

            <div>
              {_.summary && <>
                <h5 className="tw-uppercase tw-text-primary">In summary</h5>
                <p>{_.summary}</p>
              </>}
            </div>
          </Section>
        )}
      </div>
    </App>
  );
}
